import { CLEAR_PROMOTION_VALUE, SEND_PROMOTION_CODE } from "app/actionTypes";
import axios from "axios";
import { getCredentials } from "app/utils/auth";
import env from "app/utils/env";

export const sendPromotionCode = promotionCode => {
	const { token } = getCredentials();
	return {
		type: SEND_PROMOTION_CODE,
		promise: axios.post(`${env("QUOTE_API_URL")}/promoCode`, promotionCode, {
			headers: {
				Authorization: token,
				"Content-type": "application/json",
			},
		}),
	};
};

export const clearPromotionValue = () => {
	return {
		type: CLEAR_PROMOTION_VALUE,
	};
};
